<template>
  <div id="survey-questions-manage" v-if="surveyQuestions">
    <div class="survey-questions-header">
      <span>BROJ</span>
      <span>PITANJE</span>
      <span>ZA RADIONICU</span>
      <span>VRSTA UNOSA</span>
    </div>
    <div class="survey-questions" v-for="(surveyQuestion, index) in surveyQuestions" v-bind:key="surveyQuestion.id">
      <span>{{ index + 1 }}.</span>
      <span>{{ surveyQuestion.question }}</span>
      <span>{{ surveyQuestion.isForWorkshop }}</span>
      <span>{{ surveyQuestion.questionType }}</span>
      <button type="button" v-on:click="openAddEditModal(surveyQuestion)">UREDI</button>
      <button type="button" v-on:click="deleteSurveyQuestion(surveyQuestion)">IZBRIŠI</button>
    </div>
    <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
    <AddEditSurveyQuestionsModal
      v-if="modalVisible"
      v-on:cancel="resetSurveyQuestion"
      v-on:save="saveSurveyQuestion"
      v-bind:surveyQuestion="surveyQuestionForModal"
    />
  </div>
</template>

<script>
import AddEditSurveyQuestionsModal from '@/components/admin/surveyQuestions/AddEditSurveyQuestionsModal';

export default {
  name: 'SurveyQuestionManage',
  data() {
    return {
      surveyQuestions: [],
      surveyQuestionForModal: {},
      modalVisible: false,
    };
  },
  components: {
    AddEditSurveyQuestionsModal,
  },
  methods: {
    openAddEditModal: function(surveyQuestion) {
      this.surveyQuestionForModal = surveyQuestion ? surveyQuestion : {};
      this.modalVisible = true;
    },
    saveSurveyQuestion: function(surveyQuestionToSave) {
      if (surveyQuestionToSave.id) {
        this.$axios.post(`${this.$API_URL}/survey-questions/edit`, surveyQuestionToSave).catch(() => {
          this.$axios
            .get(`${this.$API_URL}/survey-questions/${surveyQuestionToSave.id}`)
            .then(response => {
              this.surveyQuestions.splice(
                this.surveyQuestions.findIndex(surveyQuestion => surveyQuestion.id === surveyQuestionToSave.id),
                1,
                response.data,
              );
              alert('Edit pitanja neuspješan. Nevaljan unos ili zabranjen pristup.');
            })
            .catch(() => {
              alert('Pokušan je edit nepostojećeg pitanja!');
            });
        });
      } else
        this.$axios
          .post(`${this.$API_URL}/survey-questions/add`, surveyQuestionToSave)
          .then(response => {
            surveyQuestionToSave.id = response.data;
            this.surveyQuestions.push(surveyQuestionToSave);
          })
          .catch(() => {
            alert('Dodavanje pitanja neuspješno. Dupli unos (ime) ili zabranjen pristup.');
          });
      this.modalVisible = false;
    },
    resetSurveyQuestion: function(surveyQuestionToReset) {
      if (surveyQuestionToReset.id)
        this.$axios.get(`${this.$API_URL}/survey-questions/${surveyQuestionToReset.id}`).then(response => {
          this.surveyQuestions.splice(
            this.surveyQuestions.findIndex(surveyQuestion => surveyQuestion.id === surveyQuestionToReset.id),
            1,
            response.data,
          );
        });
      this.modalVisible = false;
    },
    deleteSurveyQuestion: function(surveyQuestionToDelete) {
      if (confirm(`Jeste li sigurni da želite izbrisati pitanje ${surveyQuestionToDelete.question}?`))
        this.$axios
          .delete(`${this.$API_URL}/survey-questions/delete/${surveyQuestionToDelete.id}`)
          .then(() => {
            this.surveyQuestions.splice(
              this.surveyQuestions.findIndex(surveyQuestion => surveyQuestion.id === surveyQuestionToDelete.id),
              1,
            );
          })
          .catch(() => {
            alert('Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.');
          });
    },
  },
  created() {
    this.$axios
      .get(`${this.$API_URL}/survey-questions/all-survey-questions`)
      .then(response => {
        this.surveyQuestions = response.data;
      })
      .catch(() => {
        alert('Greška u dohvaćanju pitanja.');
      });
  },
};
</script>

<style scoped>
#survey-questions-manage {
  color: white;
}

.survey-questions-header,
.survey-questions {
  display: flex;
}

span {
  flex-basis: 20%;
  word-wrap: break-word;
  display: inline-block;
  height: auto;
  margin-right: 5px;
  vertical-align: center;
}

span:nth-child(1) {
  flex-basis: 5%;
}

button {
  padding: 6px;
}
</style>
